module.exports = __webpack_public_path__ + "static/media/l4.162bcd6a.png";